import { gateway } from "../../../gateway";

export const updateVendor = async (token: string | null, payload: any) => {
  try {
    const res = await gateway.patch(`/vendors`, payload, {
      headers: {
        Authorization: `${token}`,
      },
    });
    return res.data || res.data?.data;
  } catch (error) {
    throw error;
  }
};
